import createApi from '@/services/Api';
import store from '@/store';
import moment from 'moment';

function Queue() {
  const api = createApi();

  function fetch() {
    const endpoint = '/profissional-saude/fila/atendimento/listar',
      { filtered } = store.state.queue;

    return api.post(
      endpoint,
      {
        params: {
          flagTodasEspecialidades: !filtered,
        },
      },
      {
        transformResponse: [
          ...api.defaults.transformResponse,
          data => {
            data.object = filterFethedData(data.object);
            return data;
          },
        ],
      },
    );
  }

  function filterFethedData(queueList) {
    const queue = queueList.map(
      ({
        id,
        idAtendimento,
        idProfissional,
        nomePaciente,
        dataEntrada,
        ultimaVezOnlineEmSegundos,
        tipoAtendimento,
        nomeClinica,
        nomeEspecialidade,
        idade,
        nomeUsuarioInclusao,
      }) => {
        const formatedDate = brDateToIso(dataEntrada);

        const obj = Object.assign({
          id,
          patient: {
            isOnline: ultimaVezOnlineEmSegundos <= 90,
            name: nomePaciente,
            age: idade,
          },
          meetingId: idAtendimento,
          professionalId: idProfissional,
          requester: {
            name: nomeUsuarioInclusao,
          },
          schedulingDate: formatedDate ? moment(formatedDate) : null,
          meetType: tipoAtendimento,
          clinic: {
            name: nomeClinica,
          },
          specialty: nomeEspecialidade,
        });

        return obj;
      },
    );

    return queue;
  }

  function brDateToIso(dateString) {
    dateString = String(dateString);
    try {
      let [date, time] = dateString.split(' ');
      const parsedOnlyDate = date.split('/').reverse().join('-');

      return `${parsedOnlyDate} ${time}`;
    } catch {
      return null;
    }
  }

  function acceptQueue(queueItemId) {
    const endpoint = `/profissional-saude/fila/atendimento/aceitar/${queueItemId}`;

    return api.post(endpoint);
  }

  function acceptInterconsultation(queueItemId) {
    const endpoint = `/profissional-saude/fila/atendimento/aceitar-interconsulta/${queueItemId}`;

    return api.post(endpoint);
  }

  return { fetch, acceptQueue, acceptInterconsultation };
}

export default Queue();
